export enum ToastType {
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
}
